<template>
  <div class="home">
    <div>
      <ad-model :adCode="635"></ad-model>
      <logo-search></logo-search>
      <swiper :topNav="topNav" :secNav="secNav" :thirdNav="thirdNav"></swiper>
      <div class="adBox"><ad-model :adCode="665"></ad-model></div>
      <keep-alive>
        <cart :showCartForm="showCartForm"></cart>
      </keep-alive>
      <div class="adBox"><ad-model :adCode="636"></ad-model></div>
      <!-- <guess></guess> -->
      <featured-campus title="精选校区"></featured-campus>
<!--      <countdown></countdown>-->
      <div>
        <class-floor></class-floor>
      </div>
      <keep-alive>
        <div class="adBox"><ad-model :adCode="637"></ad-model></div>
        <!-- <QRCode /> -->
      </keep-alive>
    </div>
  </div>
</template>

<script>
import jsonp from 'js/jsonp.js'
import { mapState } from 'vuex'
import { objCompare } from 'js/compare.js'
import Cart from '@/common-components/Cart'
import AdModel from '@/common-components/AdModel'
import LogoSearch from './components/logo-search/Logosearch'
import Swiper from './components/swiper/Swiper'
import Countdown from './components/Countdown'
import QRCode from '@/common-components/QRCode'

const FeaturedCampus = r => require.ensure([], () => r(require('./components/Featuredcampus')))
const Guess = r => require.ensure([], () => r(require('./components/Guess')))
const ClassFloor = r => require.ensure([], () => r(require('./components/class-floor/Classfloor')))
export default {
  name: 'Home',
  components: {
    Cart,
    AdModel,
    LogoSearch,
    Swiper,
    FeaturedCampus,
    Countdown,
    Guess,
    ClassFloor,
    QRCode
  },
  data () {
    return {
      topNav: [],
      secNav: [],
      thirdNav: [],
      currentIndex: -1,
      showCartForm:true
    }
  },
  computed: {
    cityId () {
      return this.soukecityId
    },
    ...mapState(['soukecityId', 'cityName'])
  },
  watch: {
    cityId (newVal) {
      if (newVal) {
        this.allNavInit()
        this.getAllNavData(newVal)
      }
    }
  },
  created () {
    if (this.cityId) {
      this.getAllNavData(this.cityId)
    }
    console.log(`
   ____    ____              ______                    _____
  /\\   \\  /\\   \\            /::\\   \\                  /\\    \\
 /::\\   \\/::\\___\\          /::::\\   \\                /::\\    \\
 \\:::\\  ::::/   /         /::__::\\   \\              /::::\\    \\
  \\:::\\::::/   /         /::/\\ \\::\\   \\            /::::::\\    \\
   \\::::::/   /         /::/ /\\ \\::\\___\\          /:::/\\:::\\    \\
    \\::::/___/         /::/ /  \\_\\:|   |         /:::/  \\:::\\    \\
    /::::\\   \\        /::/ /   |_|:|___|        /:::/   /\\:::\\    \\
   /::::::\\   \\      /::/ /    / /:/   /       /::::\\   \\ \\:::\\    \\
  /:::/\\:::\\   \\     \\::\\ \\   / /:/   /       /::::::\\   \\ \\:::\\____\\
 /:::/  \\:::\\   \\     \\::\\ \\_/ /:/   /       /:::/\\:::\\___\\ \\::/    /
/:::/   /\\:::\\___\\     \\::\\___/:/   /       /:::/  \\::/   /  \\/____/
\\::/   /  \\::/   /      \\::::::/   /        \\::/   /\\/___/
 \\/___/    \\/___/        \\____/___/          \\/___/
      `)
  },
  methods: {
    allNavInit () {
      this.topNav = []
      this.secNav = []
      this.thirdNav = []
    },
    getAllNavData (cityId) {
      jsonp('http://deploy.xdf.cn/api/Soukeapi/souke', {
        method: 'NavCategory/GetNavCategoryByCity',
        param: JSON.stringify({cityId})
      }).then(res => {
        this.getTopNav(res)
      })
    },
    getTopNav (res) {
      let _this = this
      this.topNav = []
      res.filter(function (item, index) {
        if (item.ParentCode === '') {
          _this.topNav.push(item)
        }
      })
      this.topNav.sort(objCompare('SortIndex'))
      this.getSecNav(this.topNav, res)
      this.$store.commit('changeTopNav', this.topNav)
    },
    getSecNav (topNav, alldata) {
      let _this = this
      this.secNav = []
      topNav.forEach((topItem, topIndex) => {
        alldata.filter(function (item, index) {
          if (topItem.Code === item.ParentCode) {
            if (_this.secNav[topIndex] === undefined) {
              _this.secNav[topIndex] = []
            }
            _this.secNav[topIndex].push(item)
          }
        })
        if (_this.secNav[topIndex]) {
          _this.secNav[topIndex].sort(objCompare('SortIndex'))
        }
      })
      this.getThirdNav(_this.secNav, alldata)
    },
    getThirdNav (secNav, alldata) {
      let _this = this
      this.thirdNav = []
      for (let i = 0; i < secNav.length; i++) {
        if (_this.thirdNav[i] === undefined) {
          _this.thirdNav[i] = []
        }
        for (let j = 0; j < secNav[i].length; j++) {
          alldata.filter(function (third, thirdIndex) {
            if (third.ParentCode === secNav[i][j].Code) {
              if (_this.thirdNav[i][j] === undefined) {
                _this.thirdNav[i][j] = []
              }
              _this.thirdNav[i][j].push(third)
            }
          })
          if (_this.thirdNav[i][j]) {
            _this.thirdNav[i][j].sort(objCompare('SortIndex'))
          }
        }
      }
    },
    handleMouseEnter (index) {
      this.currentIndex = index
    },
    handleMouseLeave () {
      this.currentIndex = -1
    }
  }
}
</script>

<style lang="stylus">
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s
}
.fade-enter, .fade-leave-to {
  opacity: 0
}
.home
  margin: 0 auto
  .adBox
    width: 1200px
    margin: 20px auto
.floors, .countdown, .campus, #guessBox, .adBox, #main{
  padding-bottom:12px
}
</style>



// WEBPACK FOOTER //
// src/pages/home/Home.vue